import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    isLoading?: boolean;
    variant?: 'primary' | 'ghost' | 'soft' | 'active' | 'outline';
    size?: 'sm' | 'md' | 'lg';
    shape?: 'circle' | 'pill' | 'default';
}

export function Button({
    children,
    className = "",
    isLoading = false,
    variant,
    size,
    shape = 'pill',
    disabled,
    ...props
}: ButtonProps) {
    const baseClass = "btn";

    // Variant styles
    let variantClass = "";
    if (variant === "primary") variantClass = "btn-primary";
    else if (variant === "ghost") variantClass = "btn-ghost";
    else if (variant === "soft") variantClass = "btn-soft";
    else if (variant === "active") variantClass = "btn-active";
    else if (variant === "outline") variantClass = "btn-outline";

    // Size styles
    let sizeClass = "";
    if (size === "sm") sizeClass = "btn-sm";
    else if (size === "lg") sizeClass = "btn-lg";

    // Shape styles
    let shapeClass = "";
    if (shape === "circle") shapeClass = "btn-circle";
    else if (shape === "pill") shapeClass = "rounded-full";

    const classes = [
        baseClass,
        variantClass,
        sizeClass,
        shapeClass,
        className
    ].filter(Boolean).join(" ");

    return (
        <button
            className={classes}
            disabled={disabled || isLoading}
            {...props}
        >
            {isLoading ? <span className="loading loading-spinner loading-xs"></span> : children}
        </button>
    );
}
